'use strict';

angular.module('clientDashboardApp').directive('loadingStatus', function () {
    return {
        restrict: 'A',
        replace: true,
        transclude: true,
        scope: {
            dataLoaded: '=loadingStatus'
        },
        template: '<div>' +
            '<div ng-if="!dataLoaded" class="text-center w-100"><h4 class="loading">Loading</h4><i class="fas fa-spinner fa-spin fa-2x"></i></div>' +
            '<div ng-if="dataLoaded" class="w-100" ng-transclude></div>' +
            '</div>'
    }
});
